import { type ValueOf } from '@models/helpers/custom'
import { type FieldWithValidationType } from '@models/ui/fields'
import { type InputErrorsMapType } from '@models/ui/inputs'

export const CreateInvoiceFormFields = {
  USER_ID: 'user_id',
  FIRST_NAME: 'first_name',
  SURNAME: 'surname',
  EMAIL: 'email',
  PHONE: 'phone',
  BANK_CODE: 'bank_code',
  ADDRESS: 'address',
  COUNTRY: 'country',
  COUNTRY_CODE: 'country_code',
  CITY: 'city',
  STREET: 'street',
  POSTAL_CODE: 'postal_code',
  BIRTH_DATE: 'birth_date'
} as const

export type CreateInvoiceFormFieldType = ValueOf<typeof CreateInvoiceFormFields>
export type CreateInvoiceFormFieldsValidationType = Record<CreateInvoiceFormFieldType, InputErrorsMapType>
export type CreateInvoiceFormDataType = Record<CreateInvoiceFormFieldType, string>
export type CreateInvoiceFormFieldsType = {
  [key in CreateInvoiceFormFieldType]: {
    isShown: boolean;
    inputEl: FieldWithValidationType | null;
    inputVal: string | Date | null;
  }
}

export type CreateInvoiceFormFieldChoicesType = {
  bank_code?: string[];
}
